import { CSSProperties } from 'react';

import LottieView from 'lottie-react-native';
import { ViewStyle } from 'react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';

// Only use common props values here. Don't use specific platform styles
const commonStyles: ViewStyle | CSSProperties = {
  left: -35,
  bottom: -50,
  height: 170,
  width: 170,
  zIndex: 1,
  position: 'absolute',
};

export const ConfettiAnimation = ({
  onAnimationFinish,
  onAnimationLoop,
  loop = false,
}: {
  onAnimationFinish?: () => void;
  onAnimationLoop?: () => void;
  loop?: boolean;
}) => {
  const uri = useStaticLottieUri(StaticImages.ConfettiRewardsButton);

  if (!uri) {
    return null;
  }

  return (
    <LottieView
      key={uri}
      source={{ uri }}
      loop={loop}
      resizeMode="cover"
      autoPlay={true}
      style={commonStyles as ViewStyle}
      webStyle={commonStyles as CSSProperties}
      onAnimationLoop={onAnimationLoop}
      onAnimationFinish={() => {
        onAnimationFinish?.();
      }}
    />
  );
};
